import closeIco from '@assets/generalItems/deleteCrossGray.png'
import { ItemZoneContext } from '@context/ItemZoneContext'
import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { ReactNode, useContext } from 'react'

type Props = {
  children: ReactNode
  closeFn: () => void
}

export function EditorWrapper({ children, closeFn }: Props) {
  const t = useAppStore.use.t()
  const { currentTexture } = useContext(ItemZoneContext)
  const objectName = useAppStore(
    (s) =>
      s.items.get(s.currentObjectID)?.description ?? s.areas.get(s.currentObjectID)?.description,
  )

  return (
    <Dialog.Content
      onInteractOutside={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      <Dialog.Overlay className='white-background absolute bottom-0 left-0 right-0 top-0 m-auto h-[720px]  w-[1450px] grid-cols-2 content-center overflow-hidden rounded-xl bg-C/Color1'>
        <Dialog.Title className='sr-only'>{'Universal'}</Dialog.Title>
        <Dialog.Description className='sr-only'>
          {'Universal'} - {'Menu de Preferencias'}
        </Dialog.Description>
        <Dialog.Close className='absolute right-3 top-3 z-[100] cursor-pointer'>
          <img
            className='h-2.5'
            src={closeIco}
            onClick={closeFn}
          />
        </Dialog.Close>
        <div className=' relative ml-0 mt-0 grid h-[720px] grid-cols-[1.15fr_3fr] rounded-xl border-2 border-C/Color3'>
          <section className='relative flex items-center justify-between border-r-2 border-white bg-C/Color3 py-1.5 text-sm font-bold text-C/Color1'>
            <div className='ml-2 flex-1 text-left'>
              {'Zona '} {t(objectName)}
            </div>
            <div className='absolute left-1/2 top-1/2 ml-[2px] h-8 w-[2px] -translate-x-1/2 -translate-y-1/2 transform bg-white'></div>
            <div className='max-w-[290px] flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left'>
              {'Selecciona Material'}
            </div>
          </section>
          <section className='bg-C/Color3 py-1.5 pl-3 text-center text-sm font-bold text-C/Color1'>
            {'Selecciona Acabados'} | {t(currentTexture?.zoneDisplayName)}
          </section>
          {children}
        </div>
      </Dialog.Overlay>
    </Dialog.Content>
  )
}
